import { Component, inject } from '@angular/core';
import * as bootstrap from 'bootstrap';
import { ToastrService } from 'ngx-toastr';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { EncryptionService } from 'src/app/services/encryption.service';
import { AppService } from 'src/app/services/services';

@Component({
  selector: 'app-chatbot',
  templateUrl: './chatbot.component.html',
  styleUrls: ['./chatbot.component.scss']
})
export class ChatbotComponent {

  public loader = inject(NgxUiLoaderService);
  private http = inject(EncryptionService);
  private _http = inject(AppService);
  private toastr = inject(ToastrService);

  ngAfterViewInit(){
      const exampleEl = document.getElementById('tool') as HTMLDivElement;
      const tooltip = new bootstrap.Tooltip(exampleEl, {animation: true, trigger:"hover",title:"Need Help?",customClass:"custom-tooltip"});
  }

  
  contactUs(){
    let refNo = sessionStorage.getItem('AxNo');
    this.loader.start();
    let params = {
      "ReferenceNumber":refNo,
      "IsCallBack": true
    }
    const path = `DIY/PostCustomerDetailToAmeyo`;
    let checksum = refNo;
    this._http.httpPost(path,params,checksum).subscribe({
      next: (data:any) => {
        this.loader.stop();
        let decryption = this.http.decryptUsingAES256(data.OutPut);
        // this.toastr.success("Our support person will contact you soon!")
        
      },error: (e:any) => {
        this.toastr.error(e.error.Message);
        this.loader.stop();
      }
    })
  }
}
